import { render, staticRenderFns } from "./FacilityCreateSupervisor.vue?vue&type=template&id=39b3b1fc&"
import script from "./FacilityCreateSupervisor.vue?vue&type=script&lang=js&"
export * from "./FacilityCreateSupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports